<div>
  <div fxLayoutAlign="space-between center">
    <h1 mat-dialog-title>Journalnummer formatering</h1>
    <button class="mr-3" mat-icon-button mat-dialog-close><mat-icon>close</mat-icon></button>
  </div>
  <mat-divider></mat-divider>
</div>
<div mat-dialog-content>
  <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="1em" class="mb-3">
    <div fxFlex="45">
      <h4 class="mb-0">Regler</h4>
      <ol>
        <li>Journalnummer formatet gælder <em>kun</em> denne kategori.</li>
        <li>Du kan indsætte dynamiske felter, fx kategoriinitialer, årstal og løbenummer.</li>
        <li>Du kan indtaste anden tekst, fx bindestreger. tal eller lign.</li>
        <li>Du kan ændre rækkefølgen med "drag-and-drop".</li>
        <li>Hvis intet er angivet følges det generelle format (se Indstillinger / Journalnummer)</li>
      </ol>
    </div>
    <mat-divider [vertical]="true"></mat-divider>
    <div fxFlex="45">
      <app-pattern-editor
        [control]="control"
        [pattern]="category.journal_no_pattern"
        [category]="category.initials"
        (patternChanged)="onPatternChanged($event)">
      </app-pattern-editor>
    </div>
  </div>
</div>
<div mat-dialog-actions fxLayoutAlign="end">
  <button mat-stroked-button (click)="clearJournalNoPattern()">Ryd regel</button>
  <button mat-flat-button (click)="saveJournalNoPattern()" color="primary">Gem</button>
</div>
